export const getProcessinguuid = () => {
  const processingUuid = window.localStorage.getItem('processing_uuid')
  return processingUuid || ''
}

export const getFingerprint = () => {
  const fingerprint = JSON.parse(window.localStorage.getItem('fingerprint'))
  return fingerprint?.visitorId ?? ''
}

export const getAccount = () => {
  if (typeof window === 'undefined') return ''
  const loggedUser = window.localStorage.getItem('loggedUser')
  if (!loggedUser) return ''
  try {
    return JSON.parse(loggedUser).id_account ?? ''
  } catch {
    return ''
  }
}
